import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from 'api/axios/foka'
import { createAxiosThunk } from 'utils/reduxUtil'

export const DOCUMENT_FILE_SIZE_LIMIT = 1024 * 1024 * 10

const initialState = {
  channels: [],
  reviewDocumentTypes: [
    { id: 'BIZ_CHANNEL', name: 'channel', desc: '비즈채널 심사용' },
    { id: 'CREATIVE', name: 'creative', desc: '소재 심사용' },
  ],
  selectedChannel: null,
  selectedReviewDocumentType: null,
  isChannelLoading: true,
  reviewDocumentsOld: [],
  reviewDocuments: [],
  requiredDocumentTypes: [],
  uploadDocuments: [],
  error: null,
}

export const fetchChannels = createAxiosThunk(
  'documentList/fetchChannels',
  () => api.ad.getBizChannels()
)

export const addReviewDocuments = createAxiosThunk(
  'documentAdd/addReviewDocument',
  (reviewDocuments, { getState }) => {
    const { selectedChannel } = getState().document.documentAdd
    return api.document.addDocument({
      channelId: selectedChannel.id,
      documents: reviewDocuments,
    })
  }
)

export const uploadDocumentFiles = createAsyncThunk(
  'documentAdd/uploadDocumentFiles',
  async (files, { rejectWithValue }) => {
    try {
      const response = await api.document.uploadDocumentFiles(files)
      return response.map(e => e.data)
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

const addDocumentSlice = createSlice({
  name: 'documentAdd',
  initialState,

  reducers: {
    reset: () => initialState,
    selectChannel: (state, { payload: channel }) => {
      state.selectedChannel = channel
    },
    selectReviewDocumentType: (state, { payload: type }) => {
      state.selectedReviewDocumentType = type
    },
    setReviewDocuments: state => {
      const {
        selectedChannel: channel,
        selectedReviewDocumentType: documentType,
      } = state
      const documents =
        documentType.id === 'CREATIVE'
          ? channel.creativeDocuments
          : channel.channelDocuments

      state.reviewDocumentsOld = documents.files
      state.requiredDocumentTypes = documents.requiredDocuments
      state.uploadDocuments = []
    },
    addDocument: (state, { payload: document }) => {
      state.uploadDocuments.push(document)
    },
    deleteDocument: (state, { payload: fileId }) => {
      state.uploadDocuments = state.uploadDocuments.filter(
        d => d.fileId !== fileId
      )
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchChannels.pending, state => {
      state.isChannelLoading = true
    })

    builder.addCase(fetchChannels.fulfilled, (state, { payload }) => {
      state.channels = payload.content.map(
        ({
          id,
          name,
          siteUrl: { pcUrl, mobileUrl },
          reviewDocuments,
          reviewStatus,
          bizChannelCategory,
        }) => {
          const creativeDocumentFiles = reviewDocuments.filter(
            d => d.reviewDocumentType === 'CREATIVE'
          )
          const channelDocumentFiles = reviewDocuments.filter(
            d => d.reviewDocumentType === 'BIZ_CHANNEL'
          )
          return {
            id,
            name,
            reviewStatus,
            siteUrl: {
              mobileUrl:
                mobileUrl &&
                `${mobileUrl.protocol.toLowerCase()}://${mobileUrl.url}`,
              pcUrl: pcUrl && `${pcUrl.protocol.toLowerCase()}://${pcUrl.url}`,
            },
            categoryFullPath: bizChannelCategory.categoryFullPath,
            creativeDocuments: {
              files: creativeDocumentFiles,
              requiredDocuments: [
                ...bizChannelCategory.reviewRequiredDocuments.filter(
                  d => d.reviewDocumentType === 'CREATIVE'
                ),
              ],
            },
            channelDocuments: {
              files: channelDocumentFiles,
              requiredDocuments:
                bizChannelCategory.reviewRequiredDocuments.filter(
                  d => d.reviewDocumentType === 'BIZ_CHANNEL'
                ),
            },
          }
        }
      )
      state.isChannelLoading = false
    })

    builder.addCase(fetchChannels.rejected, (state, action) => {
      state.error = action.payload || true
      state.isChannelLoading = false
    })
  },
})

export const {
  reset,
  selectChannel,
  selectReviewDocumentType,
  setReviewDocuments,
  addDocument,
  deleteDocument,
} = addDocumentSlice.actions

export default addDocumentSlice.reducer
